export enum CmpConfigIntegrationType {
    WEB = "WEB",
    GTM = "GTM",
    CMS = "CMS",
    AMP = "AMP"
}
